import axios from 'axios';
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { isAndroid, isIOS } from 'react-device-detect';
import ClaimGift from './ClaimGift';

const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.qwrtx.dropora";
const IOS_URL = "https://apps.apple.com/us/app/dropora/id6478829126?platform=iphone";
const WEB_URL = "https://dropora.com";

function getStoreUrl() {
  if (isAndroid) return ANDROID_URL;
  if (isIOS) return IOS_URL;
  return WEB_URL;
}

function HomePage() {
  const storeUrl = getStoreUrl();

  useEffect(() => {
    // Fire-and-forget: tracking ne doit pas bloquer la redirection
    try {
      let params = new URL(document.location.toString()).searchParams;
      const token = params.get("campaign");
      if (token) {
        axios.get(`https://api.dropora.com/api/v1/campaigns/count/${token}`).catch(() => {});
      }
    } catch (e) {}

    window.location.href = storeUrl;
  }, [storeUrl]);

  return (
    <div style={{ textAlign: 'center', marginTop: '30vh', fontFamily: 'sans-serif' }}>
      <p>Redirecting to store... / Redirection vers le store...</p>
      <a href={storeUrl} style={{ fontSize: '1.1rem' }}>Click here if not redirected / Cliquez ici si vous n'êtes pas redirigé</a>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/claim-gift" element={<ClaimGift />} />
    </Routes>
  );
}

export default App;
